/**
 * Contratos compartidos entre la API y las aplicaciones de front.
 * Una sola definición de cada forma — ver vault/10-Contexto/Estandares.md
 */
// El catálogo de módulos volvió aquí en T-21, como decía la nota que estaba en
// su lugar: la API ya tomó la dependencia de este paquete. Ver ./modulos.ts
export * from './modulos.js';
export * from './esquemas.js';
// F3 · El contrato del menú. Congelado durante la ola 2: quien crea que una forma
// está mal, para y lo dice — no la cambia mientras otros construyen contra ella.
export * from './menu.js';
//  `T-49` · «Mi cafetería» — ADR-029. En su propio módulo porque es la primera
//  sección del panel que NO pertenece a un módulo: se ve con menú o sin él.
export * from './mi-cafeteria.js';
//  `F4` · El alta del comensal, en el suyo: es del comensal, no del dueño.
export * from './inscripcion.js';
//  `F5` · El mostrador. Aparte de `inscripcion.js` porque aquello es del
//  comensal y esto del personal: dos superficies, dos roles y dos riesgos.
export * from './mostrador.js';
// ADR-015 · Color y contraste. Sin dependencias: los usa la API para validar.
export * from './paleta.js';
// T-33 · La subida de imágenes con URL firmada. Se AÑADE en la ola 2 y no toca
// nada de `menu.js`, que está congelado: es una superficie nueva, no un cambio
// de forma sobre la que otros ya están construyendo.
export * from './subida.js';
// M-10 y M-11 · Lo que el comensal mira y busca en el menú público. Se AÑADE por
// el mismo camino que `subida.js` y por el mismo motivo: `menu.js` sigue
// congelado y esto es una superficie nueva. Lo único que toma de allí es
// `esquemaId`, importado y no copiado.
export * from './codigo-de-qr.js';
//  `F4` · El código efímero del mostrador. Aparte de `codigo-de-qr.js` porque
//  son dos cosas distintas con el mismo alfabeto: aquél es la dirección impresa
//  de una mesa y dura años; éste identifica a una persona y dura tres minutos.
export * from './codigo-de-tarjeta.js';
//  `F5` · `T-53` · Qué es lo que la cajera acaba de teclear en el campo único.
//  Vive con los códigos porque de ellos depende —el alfabeto y los dos largos—,
//  y aparte porque además reconoce un teléfono, que no es un código de nada.
export * from './busqueda-de-mostrador.js';
//  `F5` · `T-56` · `R-05` · Cuánto le queda a un premio, y desde cuándo eso se
//  dice fuerte. Aparte del contrato de la tarjeta a propósito: `inscripcion.js`
//  dice QUÉ viaja y esto dice qué significa. El día que el aviso salga también
//  por SMS —pospuesto, no descartado— el criterio tiene que ser este mismo o el
//  cliente recibiría dos urgencias distintas para el mismo premio.
export * from './premio-por-vencer.js';
// T-39 · Lo que la consola pide al imprimir. Aparte de `codigo-de-qr.js`: allí
// vive cómo es un código —lo comparten tres—, y aquí qué se pide y qué se
// devuelve al imprimir, que sólo lo usan la consola y la API.
export * from './papeles-de-qr.js';
export * from './eventos-del-menu.js';
export const centavos = (n) => {
    if (!Number.isInteger(n))
        throw new RangeError('Un monto en centavos debe ser entero');
    return n;
};
//  `F6` · Lo que el panel lee del programa de sellos. Tercera superficie de
//  lealtad, y por eso tercer archivo: `inscripcion.js` es del comensal,
//  `mostrador.js` del personal de caja, y esto del dueño.
export * from './lealtad.js';
//  `T-65` · El personal y sus tablets. Aparte de `lealtad.js` porque es otra
//  sección y otro permiso: aquello es el negocio por dentro y esto es quién
//  tiene llaves.
export * from './personal.js';
export * from './telefono.js';
//# sourceMappingURL=index.js.map